export default __webpack_public_path__ + "static/media/nextDoor.8460b5b5.svg";